/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Modal, Tag, Tabs, Card, Descriptions, Progress, Row, Col } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import { showErrorNotification, showSuccessNotification } from "../../../../utils/notification";

const { TabPane } = Tabs;

const UserProgressModal = ({
  userId,
  courseId,
  isModalOpen = false,
  setIsModalOpen = () => {},
  ROOT_URL
}) => {
  const [tasksList, setTasksList] = useState([]);
  const [lecturesList, setLecturesList] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  const fetchUserProgress = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${ROOT_URL}/admin/courses/subscriptions/progress`, {
        params: { courseId, userId }
      });
      const { tasks, lectures, stats } = res.data;
      setTasksList(tasks || []);
      setLecturesList(lectures || []);
      setStats(stats || null);
      showSuccessNotification("Progress Fetched Successfully");
    } catch (err) {
      showErrorNotification(err);
    } finally {
      setLoading(false);
    }
  };

  const taskColumns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index",
      width: 80
    },
    {
      title: "Task Name",
      dataIndex: "title",
      key: "title"
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category"
    },
    {
      title: "Type",
      key: "type",
      render: (row) => {
        if (row.bonus) return <Tag color="blue">Bonus</Tag>;
        if (row.scorable) return <Tag color="green">Scorable</Tag>;
        return <Tag color="orange">Non-Scorable</Tag>;
      }
    },
    {
      title: "Status",
      key: "status",
      render: (row) => {
        let statusObj = {
          color: row.completed ? "green" : "red",
          text: row.completed ? "COMPLETED" : "PENDING"
        };
        return <Tag color={statusObj.color}>{statusObj.text}</Tag>;
      }
    }
  ];

  const lectureColumns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index",
      width: 80
    },
    {
      title: "Section",
      dataIndex: "sectionName",
      key: "sectionName"
    },
    {
      title: "Subsection",
      dataIndex: "subsectionName",
      key: "subsectionName"
    },
    {
      title: "Status",
      key: "status",
      render: (row) => {
        let statusObj = {
          color: row.completed ? "green" : "red",
          text: row.completed ? "Watched" : "Pending"
        };
        return <Tag color={statusObj.color}>{statusObj.text}</Tag>;
      }
    }
  ];

  useEffect(() => {
    if (isModalOpen && userId && courseId) {
      fetchUserProgress();
    }
  }, [isModalOpen, userId, courseId]);

  return (
    <Modal
      title="User Progress"
      open={isModalOpen}
      footer={null}
      width={1000}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      {stats && (
        <>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={8}>
              <Card title="📊 Overall Progress" bordered={false} style={{ borderRadius: 12 }}>
                <div style={{ textAlign: "center" }}>
                  <Progress
                    type="circle"
                    percent={parseFloat(stats.completionPercentage)}
                    size={120}
                  />
                  <div style={{ marginTop: 12, fontWeight: 500 }}>
                    {stats.completionPercentage}% Completed
                  </div>
                </div>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card title="✅ Task Progress" bordered={false} style={{ borderRadius: 12 }}>
                <Descriptions column={1} size="small" bordered>
                  <Descriptions.Item label="Non-Bonus Scorable">
                    {stats.scorableTasks.completed}/{stats.scorableTasks.total}
                  </Descriptions.Item>
                  <Descriptions.Item label="Non-Scorable">
                    {stats.nonScorableTasks.completed}/{stats.nonScorableTasks.total}
                  </Descriptions.Item>
                  <Descriptions.Item label="Bonus Tasks">
                    {stats.bonusTasks.completed}/{stats.bonusTasks.total}
                  </Descriptions.Item>
                  <Descriptions.Item label="Total Tasks">{stats.totalTasks}</Descriptions.Item>
                </Descriptions>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card title="🎓 Lecture Progress" bordered={false} style={{ borderRadius: 12 }}>
                <Descriptions column={1} size="small" bordered>
                  <Descriptions.Item label="Completed Lectures">
                    {stats.completedLectures}
                  </Descriptions.Item>
                  <Descriptions.Item label="Total Lectures">
                    {stats.totalLectures}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Col>
          </Row>
        </>
      )}
      <Tabs defaultActiveKey="1">
        <TabPane tab="Tasks" key="1">
          <Table
            columns={taskColumns}
            dataSource={tasksList}
            rowKey="taskId"
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
          />
        </TabPane>

        <TabPane tab="Lectures" key="2">
          <Table
            columns={lectureColumns}
            dataSource={lecturesList}
            rowKey="subsectionId"
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
          />
        </TabPane>
      </Tabs>
    </Modal>
  );
};

export default UserProgressModal;
